/**
 * FairSiteHeader — RedisiginProductPage Header (1:719)
 * Desktop ≥1024 · Compact <1024 (Figma Size=Mibile: 1023 -)
 */

import type { FairIconName } from '@/ui/tokens/icons.data'
import { FAIR_RD_DESKTOP_MIN_WIDTH } from '@/ui/tokens/redesign.data'

export const FAIR_SITE_HEADER_SIZES = ['desktop', 'compact'] as const
export type FairSiteHeaderSize = (typeof FAIR_SITE_HEADER_SIZES)[number]

export interface FairSiteHeaderAudienceItem {
  label: string
  value: string
}

export interface FairSiteHeaderAction {
  id: string
  icon: FairIconName
  ariaLabel: string
}

export const FAIR_SITE_HEADER_DESKTOP_MIN_WIDTH = FAIR_RD_DESKTOP_MIN_WIDTH

export const FAIR_SITE_HEADER_DEFAULT_AUDIENCE: FairSiteHeaderAudienceItem[] = [
  { label: 'Women', value: 'women' },
  { label: 'Men', value: 'men' },
  { label: 'Kids', value: 'kids' },
]

export const FAIR_SITE_HEADER_DESKTOP_ACTIONS: FairSiteHeaderAction[] = [
  { id: 'style-space', icon: 'hanger', ariaLabel: 'Style space' },
  { id: 'search', icon: 'search', ariaLabel: 'Search' },
  { id: 'favorites', icon: 'favorite-outlined', ariaLabel: 'Favorites' },
  { id: 'account', icon: 'account', ariaLabel: 'Account' },
]

export const FAIR_SITE_HEADER_COMPACT_ACTIONS: FairSiteHeaderAction[] = [
  { id: 'search', icon: 'search', ariaLabel: 'Search' },
  { id: 'account', icon: 'account', ariaLabel: 'Account' },
]

/**
 * FE-026 — with the mobile bottom nav bar on screen (FE-024) the account entry
 * lives in the bar; the compact header keeps only search (Figma mobile
 * `Header` instances 11:36232 / 11:35637: menu · logo · search).
 */
export const FAIR_SITE_HEADER_COMPACT_BOTTOM_NAV_ACTIONS: FairSiteHeaderAction[] =
  FAIR_SITE_HEADER_COMPACT_ACTIONS.filter((action) => action.id !== 'account')

export function getFairSiteHeaderActions(
  size: FairSiteHeaderSize,
  hasBottomNav = false,
): FairSiteHeaderAction[] {
  if (size !== 'compact') return FAIR_SITE_HEADER_DESKTOP_ACTIONS
  return hasBottomNav
    ? FAIR_SITE_HEADER_COMPACT_BOTTOM_NAV_ACTIONS
    : FAIR_SITE_HEADER_COMPACT_ACTIONS
}

export function resolveFairSiteHeaderSize(
  width: number,
): FairSiteHeaderSize {
  return width >= FAIR_SITE_HEADER_DESKTOP_MIN_WIDTH ? 'desktop' : 'compact'
}
